/**
 * @author liqiuqi
 * @date 2022 2022/12/23 18:22
 */
import { omniAxios } from "@/utils/axios";
import { config } from "@/utils/config";

// 获取招标订阅器列表
export function restAccountTenderSubscribeGetSubscriberListByUserId() {
  return omniAxios({
    url: config.restAccountTenderSubscribeGetSubscriberListByUserIdPath,
    method: "get",
    params: {},
  });
}

// 获取招标订阅器
export function restAccountTenderSubscribeGetSubscriberById({ id, type }) {
  return omniAxios({
    url: config.restAccountTenderSubscribeGetSubscriberByIdPath + `/${id}`,
    method: "get",
    params: {
      type,
    },
  });
}

// 删除标讯
export function restAccountTenderSubscribeDelete({ id, type }) {
  return omniAxios({
    url: config.restAccountTenderSubscribeDeletePath + `/${id}`,
    method: "get",
    params: {
      type,
    },
  });
}

//获取公司简单的详情数据
export function restDetailAllTypesDetailSimpleDetail({ id, keywords }) {
  return omniAxios({
    url: config.restDetailAllTypesDetailSimpleDetailPath + `/${id}`,
    method: "get",
    params: { keywords },
  });
}

// 标讯公告模式订阅结果列表
export function restAccountSubscribeSolrListById(params) {
  return omniAxios({
    url: config.restAccountSubscribeSolrListByIdPath,
    method: "post",
    params,
    cancelLastSameRequest: true,
  });
}

// 标讯商情模式订阅结果列表
export function restAccountBusinessClueList(params) {
  return omniAxios({
    url: config.restAccountBusinessClueListPath,
    method: "get",
    params,
    cancelLastSameRequest: true,
  });
}

//批量导出
export function restAccountExportTenderSubscriberExportCheck(params) {
  return omniAxios({
    url: config.restAccountExportTenderSubscriberExportCheckPath,
    method: "post",
    params,
  });
}

// 订阅词推荐
export function restAccountSubscribeRecommendKeyword(params) {
  return omniAxios({
    url: config.restAccountSubscribeRecommendKeywordPath,
    method: "get",
    params,
  });
}

//商情模式权限
export function restAccountBusinessCluePermissionCheck() {
  return omniAxios({
    url: config.restAccountBusinessCluePermissionCheckPath,
    method: "get",
  });
}

//订阅器免费提示
export function restEnterpriseEnterpriseCompetitivenessCheckFreePop(params) {
  return omniAxios({
    url: config.restEnterpriseEnterpriseCompetitivenessCheckFreePopPath,
    method: "get",
    params,
  });
}

// 智能订阅器 获取业务类型
export function restAccountIndustryQueryBusinessList({ industryId }) {
  return omniAxios({
    url: config.restAccountIndustryQueryBusinessListPath,
    method: "get",
    params: {
      industryId,
    },
  });
}
// 保存明细方式 订阅
export function restAccountTenderSubscribeSaveTenderSummaryType(params) {
  return omniAxios({
    url: config.restAccountTenderSubscribeSaveTenderSummaryTypePath,
    method: "post",
    params,
  });
}
